module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var item = widget.item; 
    ; __append("\n\n\n<div class=\"adapted-wrapper\">\n    <div class=\"adapted-section\">\n        <div class=\"section\">\n            <div class=\"table section-list w100\">\n                ")
    ;  if (isRoot()) { 
    ; __append("\n                <div>\n                    <div class=\"title\">ID</div>\n                    <div>\n                        <div>\n                            ")
    ; __append(escapeFn( item.id ))
    ; __append("\n                        </div>\n                    </div>\n                </div>\n                ")
    ;  } 
    ; __append("\n            </div>\n        </div>\n    </div>\n    <div class=\"adapted-section\">\n        <div class=\"section\">\n            <div class=\"table section-list w100\">\n                <div>\n                    <div class=\"title\">Тип учета</div>\n                    <div>\n                        <div>\n                            ")
    ; __append(escapeFn( Util.coalesce(item.kindname, _.get(item, 'kind.name')) ))
    ; __append("\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    ")
    ;  if(item.providername) { 
    ; __append("\n    <div class=\"section\">\n        <div class=\"table section-list w100\">\n            <div>\n                <div class=\"title\">Поставщик</div>\n                <div>\n                    <div>\n                        ")
    ; __append(escapeFn( item.providername ))
    ; __append("\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    ")
    ;  } 
    ; __append("\n</div>\n<div name=\"attributes\"></div>\n")
  }
  return __output.join("");

}